import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LocalizationProvider } from './contexts/LocalizationContext';
import LoginLayout from './components/Layout/LoginLayout';
import ProtectedRoute from './components/ProtectedRoute';
import systemService from './services/systemService';
import { setSypPerUsd } from './config/store';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OrdersIndex from './pages/Orders/Index';
import OrderDetails from './pages/Orders/OrderDetails';
import ProductsIndex from './pages/Products/Index';
import CloneProductsIndex from './pages/CloneProducts/Index';
import BrandsIndex from './pages/Brands/Index';
import CategoriesIndex from './pages/Categories/Index';
import ProductTypesIndex from './pages/ProductTypes/Index';
import AdvertisementsIndex from './pages/Advertisements/Index';
import ContentSectionsIndex from './pages/ContentSections/Index';
import ContentSectionEdit from './pages/ContentSections/Edit';
import WebBannersIndex from './pages/WebBanners/Index';
import WebBannerEdit from './pages/WebBanners/Edit';
import DiscountsIndex from './pages/Discounts/Index';
import ExchangeRateSettings from './pages/Settings/ExchangeRate';
import NotificationsIndex from './pages/Notifications/Index';
import FragranceNotesIndex from './pages/FragranceNotes/Index';
import CreateFragranceNote from './pages/FragranceNotes/Create';
import UsersIndex from './pages/Users/Index';
import CreateUser from './pages/Users/CreateUser';
import PushNavigationListener from './pwa/PushNavigationListener';
import './styles/index.css';

function App() {
  useEffect(() => {
    systemService
      .getExchangeRate()
      .then((data) => setSypPerUsd(data?.sypPerUsd))
      .catch(() => {});
  }, []);

  return (
    <LocalizationProvider>
      <AuthProvider>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <PushNavigationListener />
          <Routes>
            <Route path="/login" element={
              <LoginLayout>
                <Login />
              </LoginLayout>
            } />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/home" element={<Dashboard />} />
              <Route path="/orders" element={<OrdersIndex />} />
              <Route path="/orders/:id" element={<OrderDetails />} />
              <Route path="/products" element={<ProductsIndex />} />
              <Route path="/clone-products" element={<CloneProductsIndex />} />
              <Route path="/brands" element={<BrandsIndex />} />
              <Route path="/categories" element={<CategoriesIndex />} />
              <Route path="/product-types" element={<ProductTypesIndex />} />
              <Route path="/content-sections" element={<ContentSectionsIndex />} />
              <Route path="/content-sections/new" element={<ContentSectionEdit />} />
              <Route path="/content-sections/:id" element={<ContentSectionEdit />} />
              {/* the old fixed "Home Sections" screen was replaced by Content Sections */}
              <Route path="/home-sections" element={<Navigate to="/content-sections" replace />} />
              <Route path="/web-banners" element={<WebBannersIndex />} />
              <Route path="/web-banners/new" element={<WebBannerEdit />} />
              <Route path="/web-banners/:id" element={<WebBannerEdit />} />
              <Route path="/advertisements" element={<AdvertisementsIndex />} />
              <Route path="/discounts" element={<DiscountsIndex />} />
              <Route path="/settings/exchange-rate" element={<ExchangeRateSettings />} />
              <Route path="/fragrance-notes" element={<FragranceNotesIndex />} />
              <Route path="/fragrance-notes/create" element={<CreateFragranceNote />} />
              <Route path="/admin/users" element={<UsersIndex />} />
              <Route path="/admin/users/create" element={<CreateUser />} />
              <Route path="/notifications" element={<NotificationsIndex />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LocalizationProvider>
  );
}

export default App;
